<template>
  <div class="library-banner">
    <h4 class="library-banner-text">
      {{ bannerText }}
    </h4>
    <BaseButton class="button-white" large elevation="0" @click="openConnect">
      {{ $t('LibraryBanner.guest.btn') }}
    </BaseButton>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PopupNamesEnum from '@/enums/PopupNamesEnum';
import LoginStatesEnum from '@/enums/LoginStatesEnum';
import BaseButton from '@/components/base/BaseButton/BaseButton.vue';

export default {
  name: 'LibraryBanner',
  components: {
    BaseButton
  },
  computed: {
    ...mapGetters('ContextStore', [
      'isPurchaseEnabled',
      'isLimitedGuestAccess'
    ]),
    bannerText() {
      if (this.isPurchaseEnabled) {
        return this.$t('LibraryBanner.guest.payment.title');
      }
      return this.$t('LibraryBanner.guest.title');
    }
  },
  methods: {
    openConnect() {
      this.$store.dispatch('ManagePopupStore/openPopup', {
        name: PopupNamesEnum.CONNECT,
        popupContext: { initState: LoginStatesEnum.REGISTRATION }
      });
    }
  }
};
</script>

<style lang="less" src="./LibraryGuestBanner.less"></style>
